/**
 * Service for product API calls
 */
import { apiClient } from "./Api";
import { Contentable, Company } from "@authentic-labs/vue-component-library";
import ContentSection from "@/models/ContentSection";

export async function updateContent(contentable: Contentable, payLoad: object) {
  const { data: response } = await apiClient.put(contentable.saveUrl, payLoad);
  return response.product;
}

export async function createSection(contentable: Contentable) {
  const { data: content } = await apiClient.post(contentable.newSectionUrl)
  return content;
}

export async function deleteSection(url: string) {
  const { data: response } = await apiClient.delete(url)
  return response;
}

export async function addCompanySection(url: string, newSection: ContentSection) {
  const { data: contentResponse } = await apiClient.post(url, newSection)
  return {
    company: new Company(contentResponse.company),
    contentSections: contentResponse.company.contentSection,
  };
}

